import React from "react";

import { faSkullCow } from "@fortawesome/pro-solid-svg-icons";
import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";

import Button from "components/Button";
import { Input } from "components/Form/FormikControls";
import { Row } from "components/Layout";
import { Paper } from "components/Paper";
import { MediumText as Heading } from "components/Text";

import { Error, Icon } from "./components";
import { withAttributeNamespace } from "./util";

interface HornSectionProps {
  errorMessage?: React.JSX.Element | null;
  quantity: number;
  onlyHornedOrPolled: boolean;
  namespace?: string;
  readOnly?: boolean;
}

export const HornSection = ({
  errorMessage,
  quantity,
  onlyHornedOrPolled,
  namespace,
  readOnly,
}: HornSectionProps): React.JSX.Element => {
  const { setFieldValue } = useFormikContext();
  const setAllPolled = () => {
    setFieldValue(
      withAttributeNamespace("hornPolled", namespace),
      quantity,
      false,
    );
    setFieldValue(withAttributeNamespace("hornHorned", namespace), 0, false);
    if (!onlyHornedOrPolled) {
      setFieldValue(
        withAttributeNamespace("hornDehorned", namespace),
        0,
        false,
      );
      setFieldValue(withAttributeNamespace("hornTipped", namespace), 0, false);
      setFieldValue(withAttributeNamespace("hornScurred", namespace), 0, false);
    }
  };

  return (
    <Grid item xs={12}>
      <Paper>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Row flexGrow>
              <Icon icon={faSkullCow} color="gray44" />
              <Heading>Horn (hd)</Heading>
              {errorMessage && <Error>{errorMessage}</Error>}
            </Row>
          </Grid>

          <Grid
            item
            xs={4}
            sm={2}
            style={{ display: "flex", alignItems: "flex-end" }}
          >
            <Button type="button" onClick={setAllPolled} disabled={readOnly}>
              All Polled
            </Button>
          </Grid>
          <Grid item xs={4} sm>
            <Input
              label="Polled"
              name={withAttributeNamespace("hornPolled", namespace)}
              type="number"
              emptyValue={null}
              disabled={readOnly}
            />
          </Grid>
          {!onlyHornedOrPolled && (
            <Grid item xs={4} sm>
              <Input
                label="Dehorned"
                name={withAttributeNamespace("hornDehorned", namespace)}
                type="number"
                emptyValue={null}
                disabled={readOnly}
              />
            </Grid>
          )}
          <Grid item xs={4} sm>
            <Input
              label="Horned"
              name={withAttributeNamespace("hornHorned", namespace)}
              type="number"
              emptyValue={null}
              disabled={readOnly}
            />
          </Grid>
          {!onlyHornedOrPolled && (
            <>
              <Grid item xs={4} sm>
                <Input
                  label="Tipped"
                  name={withAttributeNamespace("hornTipped", namespace)}
                  type="number"
                  emptyValue={null}
                  disabled={readOnly}
                />
              </Grid>
              <Grid item xs={4} sm>
                <Input
                  label="Scurred"
                  name={withAttributeNamespace("hornScurred", namespace)}
                  type="number"
                  emptyValue={null}
                  disabled={readOnly}
                />
              </Grid>
            </>
          )}
        </Grid>
      </Paper>
    </Grid>
  );
};
